"use strict";
/**
 * Dynamic Input Types
 * These types define the new input system that allows templates to define their own input schema.
 * The frontend will dynamically render input fields based on these definitions.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATIC_RESIZE_REFERENCE_FILE_KEY = exports.ANIMATE_STATIC_REFERENCE_FILE_KEY = exports.DynamicInputActorSelectionMode = exports.DynamicInputType = void 0;
var DynamicInputType;
(function (DynamicInputType) {
    DynamicInputType["ACTOR_SELECTION"] = "ACTOR_SELECTION";
    /** Agent flow: customize actor + scene with preview before lip-sync (speaking character) */
    DynamicInputType["ACTOR_SCENE_SELECTOR"] = "ACTOR_SCENE_SELECTOR";
    DynamicInputType["TEXT_INPUT"] = "TEXT_INPUT";
    DynamicInputType["TEXT_AREA"] = "TEXT_AREA";
    DynamicInputType["FILE_SELECTOR"] = "FILE_SELECTOR";
    DynamicInputType["LIPSYNC_SCRIPT_SELECTOR"] = "LIPSYNC_SCRIPT_SELECTOR";
    DynamicInputType["SELECT"] = "SELECT";
    DynamicInputType["LANGUAGE_SELECTOR"] = "LANGUAGE_SELECTOR";
    DynamicInputType["REVIEW_SELECTION"] = "REVIEW_SELECTION";
    DynamicInputType["GENERATION_SELECTOR"] = "GENERATION_SELECTOR";
    DynamicInputType["VIDEO_FORMAT_SELECTOR"] = "VIDEO_FORMAT_SELECTOR";
    /** Ordered pick from a passed candidate set of the brand's creatives (video-editor provide-flow). */
    DynamicInputType["CREATIVE_SELECTOR"] = "CREATIVE_SELECTOR";
    /** Visual pick from the client-owned 21-preset caption-style catalog. */
    DynamicInputType["CAPTION_STYLE_SELECTOR"] = "CAPTION_STYLE_SELECTOR";
})(DynamicInputType || (exports.DynamicInputType = DynamicInputType = {}));
var DynamicInputActorSelectionMode;
(function (DynamicInputActorSelectionMode) {
    DynamicInputActorSelectionMode["EMOTION"] = "EMOTION";
    DynamicInputActorSelectionMode["SINGLE_IN_SCENE"] = "SINGLE_IN_SCENE";
    DynamicInputActorSelectionMode["MULTIPLE"] = "MULTIPLE";
})(DynamicInputActorSelectionMode || (exports.DynamicInputActorSelectionMode = DynamicInputActorSelectionMode = {}));
exports.ANIMATE_STATIC_REFERENCE_FILE_KEY = 'referenceImages';
exports.STATIC_RESIZE_REFERENCE_FILE_KEY = 'referenceImages';
